import { ClearRefinementsProps, useClearRefinements } from 'react-instantsearch-hooks-web';
import { useSearchDictionary } from '../util';

type ClearFacetsProps = ClearRefinementsProps;

function CustomClearRefinements(props: ClearFacetsProps) {
  const { refine, canRefine } = useClearRefinements(props);
  const dict = useSearchDictionary();

  const onClick = () => {
    if (canRefine) {
      refine();
    }
  };

  if (!canRefine) {
    return <></>;
  }
  return (
    <div>
      <button type="button" onClick={onClick} disabled={!canRefine}>
        {dict.clearFilter}
      </button>
    </div>
  );
}

export default CustomClearRefinements;
